export default __webpack_public_path__ + "static/media/04_kaceci-hlavice_smidovaLCR-min.b7b98a4e.jpg";